/* eslint-disable camelcase */
export default {
  my_account: 'Мой аккаунт',
  position: 'Позиция: {0}',
  limit_hit: 'Слишком много узлов. Нажмите "Загрузить еще", чтобы загрузить больше узлов',
  load_more: 'Загрузить еще',
};
